import React from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Container from '@mui/material/Container'
import CircularProgress from '@mui/material/CircularProgress'

import { Flatpage } from '../types/flatpage'
import { get, setPageTitle } from '../utils/service'
import Alert from '../components/alert/alert'
import '../flatpage.css'

const FlatpageView = (): JSX.Element => {
  const { t } = useTranslation()
  const params = useParams()
  const flatpageUrl = params.flatpageurl

  const [isLoadingFlatpage, setIsLoadingFlatpage] = React.useState<boolean>(false)
  const [flatpageData, setFlatpageData] = React.useState<Flatpage | null>(null)
  const [loadingError, setLoadingError] = React.useState<string>('')

  // update page title
  React.useEffect(() => {
    if (flatpageData?.title) {
      setPageTitle(flatpageData?.title)
    }
  }, [flatpageData?.title])

  React.useEffect(() => {
    setIsLoadingFlatpage(true)
    setFlatpageData(null)
    setLoadingError('')

    get<Array<Flatpage>>('flatpages/?page_size=all')
      .then((response) => {
        const flatpage = response.data.find((x) => x.url === `/${flatpageUrl}/`)
        if (flatpage) {
          setIsLoadingFlatpage(false)
          setFlatpageData(flatpage)
        } else {
          setIsLoadingFlatpage(false)
          setLoadingError('flatpageview.flatpagenotfound')
        }
      })
      .catch(() => {
        setIsLoadingFlatpage(false)
        setLoadingError('flatpageview.loaderror')
      })
  }, [flatpageUrl])

  return (
    <Container component="main">
      {isLoadingFlatpage && <CircularProgress />}
      {flatpageData && <div className="flatpage" dangerouslySetInnerHTML={{ __html: flatpageData.content }} />}
      {loadingError && <Alert severity="error">{t(loadingError)}</Alert>}
    </Container>
  )
}

export default FlatpageView
